<template>
  <v-app id="inspire">
    <!--<v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
      <v-list dense>
        <template v-for="item in items">
          <v-row v-if="item.heading" :key="item.heading" align="center">
            <v-col cols="6">
              <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
            </v-col>
            <v-col cols="6" class="text-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-col>
          </v-row>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item v-for="(child, i) in item.children" :key="i" link>
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ child.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item v-else :key="item.text" :to="item.link" link>
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>-->

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      dense
      flat
      app
      style="height:50px"
      color="topo"
    >
      <!--<v-app-bar-nav-icon @click.stop="drawer = !drawer" />-->
      <v-toolbar-title color="topo" class="ml-1 pr-2 pl-1 mt-0 pt-0">
        <img
          id="imgTopo"
          src="@/assets/logo_app.png"
          alt="SUITE APP"
          class="pt-0 pb-0"
        />
        <span style="color:#E06616;font-weight:bolder;font-size:22px!important"
          >SUITE APP</span
        >
        <span
          style="padding-left:15px;color:#FFF9E9;font-size:14px"
          class="font-italic text-right font-weight-light"
        >
          ADMINISTRAÇÃO DE PEDIDOS (CARDÁPIO DIGITAL E DELIVERY APP)</span
        >
      </v-toolbar-title>
      <v-spacer />

      <!--<div class="d-flex pt-4 pr-10" cols="6" sm="6">
        <v-select filled :items="empresas" label="Empresa"></v-select>
      </div>-->
      <span class="mr-2 white--text">{{ nome }}</span>
      <v-btn @click="logout()" class="d-flex pt-1 pr-5 white--text" icon>
        <v-icon large>mdi-location-exit</v-icon>
      </v-btn>
      <template v-slot:extension>
        <v-tabs
          :hide-slider="slider"
          background-color="primary"
          align-with-title
        >
          <v-tab
            v-show="$can('admin.loja|acompanhamento.view')"
            :to="{ name: 'monitor' }"
            class="white--text"
            >Pedidos Delivery</v-tab
          >
          <v-tab
            v-show="$can('admin.loja|monitor_cardapio.view')"
            :to="{ name: 'monitor_cardapio' }"
            class="white--text"
            >Pedidos Cardápio</v-tab
          >

          <!--<v-tab
            v-show="$can('admin.loja|pedidos.view')"
            :to="{ name: 'pedidos' }"
            class="white--text"
            >Delivery</v-tab
          >-->
          <!--<v-tab
            v-show="$can('admin.loja|Entrega.view')"
            :to="{ name: 'entrega' }"
            class="white--text"
            >Entrega Programada</v-tab
          >
-->
          <!--<v-tab
            v-show="$can('admin.loja|categorias.view')"
            :to="{ name: 'categorias' }"
            class="white--text"
            >Categorias</v-tab
          >
          <v-tab
            v-show="$can('admin.loja|produtos.view')"
            :to="{ name: 'produtos' }"
            class="white--text"
            >Produtos</v-tab
          >
          <v-tab
            v-show="$can('admin.loja|promocao.view')"
            :to="{ name: 'promocao' }"
            class="white--text"
            >Promoção</v-tab
          >
          <v-tab
            v-show="$can('admin.loja|taxa_entrega.create')"
            :to="{ name: 'taxa_entrega_bairro' }"
            class="white--text"
            >Taxas Entrega</v-tab
          >
          <v-tab
            v-show="$can('admin.loja|end_retirada.view')"
            :to="{ name: 'end_retirada' }"
            class="white--text"
            >Endereços Retirada</v-tab
          >
          <v-tab
            v-show="$can('admin.loja|config.view')"
            :to="{ name: 'configuracao' }"
            class="white--text"
            >Configurações</v-tab
          >
          <v-tab
            v-show="$can('admin.loja')"
            :to="{ name: 'usuarios' }"
            class="white--text"
            >Usuários</v-tab
          >-->

          <v-menu bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                class=" white--text align-self-center mr-4"
                v-bind="attrs"
                v-on="on"
              >
                Gestão de Produtos
                <v-icon right>
                  mdi-menu-down
                </v-icon>
              </v-btn>
            </template>

            <v-list class="primary mt-9">
              <v-list-item
                min-height="30"
                dense
                v-for="item in menuProduto"
                :key="item.id"
                :disabled="!item.ativo"
                :to="{ name: item.rota }"
              >
                <v-list-item-title
                  class="white--text"
                  v-text="item.title"
                ></v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
           <v-menu bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                class=" white--text align-self-center mr-4"
                v-bind="attrs"
                v-on="on"
              >
                Montagem de Cardápios
                <v-icon right>
                  mdi-menu-down
                </v-icon>
              </v-btn>
            </template>

            <v-list class="primary mt-9">
              <v-list-item
                min-height="30"
                dense
                v-for="item in menuCardapio"
                :key="item.id"
                :disabled="!item.ativo"
                :to="{ name: item.rota }"
              >
                <v-list-item-title
                  class="white--text"
                  v-text="item.title"
                ></v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-menu bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                class=" white--text align-self-center mr-4"
                v-bind="attrs"
                v-on="on"
              >
                Gestão de Clientes
                <v-icon right>
                  mdi-menu-down
                </v-icon>
              </v-btn>
            </template>

            <v-list class="primary mt-9">
              <v-list-item
                v-for="item in menuCliente"
                :key="item.id"
                :disabled="!item.ativo"
                dense
                :to="{ name: item.rota }"
              >
                <v-list-item-title
                  class="white--text"
                  v-text="item.title"
                ></v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-menu bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                class=" white--text align-self-center mr-4"
                v-bind="attrs"
                v-on="on"
              >
                CONFIGURAÇÕES
                <v-icon right>
                  mdi-menu-down
                </v-icon>
              </v-btn>
            </template>

            <v-list class="primary mt-10">
              <v-list-item
                v-for="item in menuConfig"
                :key="item.id"
                dense
                :disabled="!item.ativo"
                :to="{ name: item.rota }"
              >
                <v-list-item-title
                  class="white--text"
                  v-text="item.title"
                ></v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <!-- <v-menu :offset-y="offsetY" transition="slide-y-transition" bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                style="margin-top:5px"
                class="white--text"
                text
                light
                color="white"
                v-on="on"
              >Cadastros</v-btn>
            </template>
            <v-list>
              <v-list-item v-for="(item, i) in itemsCad" :key="i">
                <v-list-item-title class="text-left" @click="menuto(item.rota)">
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  {{
                  item.title
                  }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-menu :offset-y="offsetY" transition="slide-y-transition" bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                style="margin-top:5px"
                class="white--text"
                text
                light
                color="white"
                v-on="on"
              >Pedidos</v-btn>
            </template>
            <v-list>
              <v-list-item v-for="(item, i) in itemsPedido" :key="i">
                <v-list-item-title class="text-left" @click="menuto(item.rota)">
                  {{
                  item.title
                  }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>-->
        </v-tabs>
      </template>
    </v-app-bar>

    <v-content id="corpo">
      <!--  <v-container class="pt-0" fluid>-->

      <router-view></router-view>

      <!--  </v-container>-->
    </v-content>
  </v-app>
</template>

<script>
export default {
  props: {
    source: String,
  },
  mounted() {
    this.nome = sessionStorage.getItem("nome");

    /*axios.defaults.headers.common["Authorization"] =
      "bearer " + sessionStorage.getItem("token");*/
  },
  methods: {
    menuto(vmenu) {
      //alert(vmenu);
      //this.$router.push("/");
      this.$router.push(vmenu);
    },
    logout() {
      window.sessionStorage.setItem("token", "");
      window.sessionStorage.setItem("tokenKey", "");
      this.$router.push("/");
    },
  },
  data: () => ({
    slider: true,
    menuCardapio: [
      {
        id: 38,
        title: "CADASTRO CARDÁPIO",
        rota: "montagem_cardapio",
        ativo: true,
        icon: "workspaces_outline",
      },
      {
        id: 39,
        title: "CADASTRO ETAPA",
        rota: "montagem_etapa",
        ativo: true,
        icon: "workspaces_outline",
      },
       {
        id: 40,
        title: "CADASTRO ITEM ETAPA",
        rota: "montagem_item",
        ativo: true,
        icon: "workspaces_outline",
      },
      {
        id: 41,
        title: "CADASTRO OBS",
        rota: "montagem_obs",
        ativo: true,
        icon: "workspaces_outline",
      }],
    menuProduto: [
      {
        id: 11,
        title: "CATEGORIAS",
        rota: "categorias",
        ativo: true,
        icon: "workspaces_outline",
      },
      {
        id: 16,
        title: "PLANO DE CATEGORIAS",
        rota: "plano_categorias",
        ativo: true,
        icon: "workspaces_outline",
      },
      {
        id: 12,
        title: "PRODUTOS",
        rota: "produtos",
        ativo: true,
        icon: "workspaces_outline",
      },
      {
        id: 13,
        title: "PROMOÇÃO",
        rota: "promocao",
        ativo: true,
        icon: "workspaces_outline",
      },
      {
        id: 14,
        title: "CAMPANHA",
        rota: "campanha",
        icon: "workspaces_outline",
        ativo: false,
      },
      {
        id: 15,
        title: "FESTIVAL",
        rota: "festival",
        icon: "workspaces_outline",
        ativo: false,
      },
    ],
    menuCliente: [
      {
        id: 21,
        title: "CLIENTES",
        rota: "clientes",
        ativo: false,
        icon: "workspaces_outline",
      },
      {
        id: 22,
        title: "PEDIDOS",
        rota: "pedidos",
        ativo: true,
        icon: "workspaces_outline",
      },
    ],
    menuConfig: [
      {
        id: 31,
        title: "GERAIS",
        rota: "configuracao",
        ativo: true,
        icon: "workspaces_outline",
      },
      {
        id: 32,
        title: "TAXA DE ENTREGA BAIRROS",
        rota: "taxa_entrega_bairro",
        ativo: true,
        icon: "workspaces_outline",
      },
      {
        id: 39,
        title: "TAXA DE ENTREGA DISTÂNCIA",
        rota: "taxa_entrega_distancia",
        ativo: true,
        icon: "workspaces_outline",
      },

      {
        id: 33,
        title: "ENDEREÇO RETIRADA",
        rota: "end_retirada",
        ativo: true,
        icon: "workspaces_outline",
      },
      {
        id: 34,
        title: "GERAR QRCODE",
        rota: "gerar_qrcode",
        ativo: true,
        icon: "workspaces_outline",
      },
      {
        id: 35,
        title: "PERFIL DE VENDAS",
        rota: "perfil_vendas",
        ativo: true,
        icon: "workspaces_outline",
      },
      {
        id: 37,
        title: "BANDEIRAS CARTÃO",
        rota: "bandeiras_cartao",
        ativo: true,
        icon: "workspaces_outline",
      },
      {
        id: 36,
        title: "USUÁRIOS",
        rota: "usuarios",
        ativo: true,
        icon: "workspaces_outline",
      },
    ],
    inset: true,
    offsetY: true,
    itemsCad: [
      { title: "Categoria", rota: "categorias", icon: "workspaces_outline" },
      { title: "Produtos", rota: "produtos", icon: "mdi-barcode" },
      {
        title: "Taxa Entrega Bairro",
        rota: "taxa_entrega_bairro",
        icon: "money_off",
      },
      { title: "Configurações", rota: "configuracao", icon: "settings" },
    ],
    itemsPedido: [
      { title: "Acompanhamento", rota: "monitor" },
      { title: "Consulta", rota: "pedidos" },
    ],
    dialog: false,
    drawer: null,
    nome: "",
    empresas: [{ text: "Empresa1" }, { text: "Tecnoweb" }],
  }),
};
</script>
<style scoped>
.v-toolbar__content {
  height: 30px !important;
}
.v-toolbar__extension {
  height: 30px !important;
}
.v-toolbar__title {
  font-size: 1rem !important;
}
#corpo {
  /* background-image: url("~@/assets/fundo_dash.jpg");*/
  background-size: cover;
  height: 100%;
  z-index: 0;
  margin-top: -96px;
}
.v-list-item {
  min-height: 30px !important;
  text-align: left !important;
}
</style>
